<template>
  <v-container class="fill-height addadvertiser" fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="12" md="12">
        <v-card class="elevation-12">
<template>
  <v-container>
    <v-row class="text-center">
      <v-col cols="12">
            <!---- Start Preview ---->
            <v-row align="center" justify="center">
            <v-col cols="12" sm="12" md="12">
            <div class="row justify-content-center border py-5">
              <div class="row justify-content-center border py-5">
                <table width="95%" >
                  <tr>
                    <td colspan="3">
                        
                      <div :style="{ backgroundImage: 'url(' + layout + ')' }" class="background-container">
                         <div class="banner-img"><img :src="bannerimage" /></div>
                      </div>
                    </td>  
                  </tr>
                   
              </table>   
              </div>  
            </div>
            </v-col>
        </v-row>
      <!---- End Preview ---->
      </v-col>
    </v-row>
  </v-container>
  </template>
  </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
//import draggable from "vuedraggable";
import 'vue-form-wizard/dist/vue-form-wizard.min.css'

//var adserverURL ="http://local.adserver.com/www/";

  export default {
    name: 'Sportstradetemplate',
    props:[
       'bannerposition',
       'bannercontentimage',
       'bannercontenthtml',
       'bannercontent',
       'bannerimage',
    ],
    components: {
          // draggable,
        },
    data: () => ({
      headersection : require("@/assets/sportstradeheadersection.png"),
      leftsection : require("@/assets/sportstradeleftsection.png"),
   //   middlesection:  require("@/assets/myyaak/middlesection.png"),
      rightsection :  require("@/assets/sportstraderightsection.png"),
      adhere: require("@/assets/506.jpg"),
      layout: require("@/assets/sportstrade.png"),
     }),
      mounted() {
     },
   computed:{
     baseURL() {
              const url = process.env.VUE_APP_BASEAPI.slice(0, -4);
              return url;
            }
     },
    methods: { 
     checkMove: function(evt){
        this.$emit("update:bannerposition", evt.to.id);
    },  
      defaultsection()
    {
       this.$emit("update:bannerposition", "leftcontent");
    }              
    }
  }
</script>
<style scoped>
.row {
  margin-left: 0px;
}
#addadvertiser .v-card__subtitle, .v-card__text, .v-card__title {
    padding: 4px !important;}
.padding-top-0{padding-top: 0px !important;}
.padding-bottom-0{padding-bottom: 0px !important;}    
.require{color: red; font-size: 15px;}
.radiolabelcls{padding-left:10px !important;}
.radiocls{padding-left:10px !important;}
.radiolabelcls{padding-left: 10px !important;padding-right: 5px !important;margin-top: -3px;
}
.errorshow{color:red;font-size: 15px;margin:0 auto;}
.draggable-list {
  color: #fff;
  border: 1px solid;
  height: 150px;
}
.list-item {
  width:100%;
  height: 100%;
  position: relative;
}
.h5{background-color: hsl(240deg 19% 82%);font-size:18px;}
.header-content{width:100%;height: 71px;}
.left-content{height: 100%; }
.center-content{height: 100%;}
.right-content{height: 100%;}
.footer-content{height: 100%; border:1px solid #b3d4fc;}
.activewebsite{
    width: 168px;
    height: 167px;
    border-radius: 85px;
    padding: 23px;
    border: 1px solid red;
    background-color: #fff;
}
.vue-form-wizard {background-color: #e1dada !important;}
.draggablecontent{background-size: 100% 100%;}
.loader,
.loader:after {  border-radius: 50%;  width: 10em;  height: 10em;}
.errormsg{font-size:20px; color: red;}
.loader {
  margin: 60px auto;
  font-size: 10px;
  position: relative;
  text-indent: -9999em;
  border-top: 1.1em solid rgba(255, 255, 255, 0.2);
  border-right: 1.1em solid rgba(255, 255, 255, 0.2);
  border-bottom: 1.1em solid rgba(255, 255, 255, 0.2);
  border-left: 1.1em solid #e74c3c;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
  -webkit-animation: load8 1.1s infinite linear;
  animation: load8 1.1s infinite linear;
}
@-webkit-keyframes load8 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes load8 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
#bannercontentimage{width:100%;height:100%;position: relative;}
#bannercontenthtml{width:100%;height:100%;position: relative;color:#000; background-color: #fff;}
.avatarcls{width: 79%;height: 70%; margin-top: 19%;}
.postionsection{width: 100%;height: 100%;}
.background-container{width: 100%;
  position: relative;
  background-size: contain;
  height: 600px;
  background-position: center;}
  .banner-img {
    width: 60%;
    position: absolute;
    top: 49%;
    height: 55px;
    left: 25%;
}
.banner-img img {
  width: 100%;
  height: inherit;
}
</style>